<app-filter-search
  [correctForm]="form"
  #filterSearch
  [searchAutoFocus]="searchAutoFocus"
  [placeholder]="searchTitle"
  *ngIf="search"
></app-filter-search>
<div *ngIf="!hideBanner">
  <img src="assets/img/banners/EcoHeroes_projects.webp" />
</div>

<div *ngIf="!hideFilters || !hideSorting" class="filters__header">
  <div class="filters__title" [ngClass]="{ 'align-left': isRanking() }">
    <div class="filters__title__wrapper--left">
      <span [innerHTML]="title"></span
      ><span
        class="clear-filters-mobile display-mobile"
        *ngIf="!hideFilters"
        (click)="clearFilters()"
        >{{ 'PROJECTS.FILTERS.clear_filters' | translate }}</span
      >
      <a
        class="btn btn--primary-light btn--sm"
        *ngIf="enabledRanking"
        [routerLink]="['/' + RoutesPath.default.ranking]"
      >
        <img src="assets/img/icons/goblet.webp" />
        {{ 'HEADER.LINKS.ranking' | translate }}
      </a>
      <a
        class="btn btn--primary-light btn--sm no-margin"
        *ngIf="!hideEnded"
        [routerLink]="[!pathToEnded ? '/' + RoutesPath.default.ended : pathToEnded]"
        [queryParams]="!endedQueryParams ? { order_by: 'most_donated' } : endedQueryParams"
      >
        <img src="assets/img/icons/check.webp" />
        {{ 'HEADER.LINKS.ended' | translate }}
      </a>
    </div>
    <button
      class="btn btn--primary-light btn--sm no-margin"
      (click)="toggleFilters()"
      *ngIf="!hideFiltersButton && !showFilters && !hideFilters"
    >
      <img src="assets/img/icons/filters.svg" [alt]="'PROJECTS.filters' | translate" />
      {{ 'PROJECTS.filters' | translate }}
    </button>
    <button
      class="btn btn--primary btn--outline btn--sm"
      (click)="toggleFilters()"
      *ngIf="showFilters"
    >
      <img
        src="assets/img/icons/filters-close.svg"
        [alt]="'PROJECTS.FILTERS.close_filters' | translate"
      />
      {{ 'PROJECTS.FILTERS.close_filters' | translate }}
    </button>
    <button class="btn btn--dark btn--outline btn--sm" (click)="clearFilters()" *ngIf="showFilters">
      {{ 'PROJECTS.FILTERS.clear_filters' | translate }}
    </button>
  </div>
  <app-sort-projects
    [correctForm]="form"
    [helpukraine]="helpukraine"
    *ngIf="sorting === 'projects' && hideSorting === false"
    #sortProjects
  ></app-sort-projects>
</div>
<div [hidden]="!showFilters" class="filters-wrapper filters-mobile">
  <div class="filters-mobile__header display-mobile">
    <span class="filters-mobile__title">{{ 'PROJECTS.FILTERS.filters' | translate }}</span>
    <span class="filters-mobile__close" (click)="toggleFilters()"
      ><img
        src="assets/img/icons/filters-close-gray.svg"
        [alt]="'PROJECTS.FILTERS.close_filters' | translate"
    /></span>
  </div>
  <app-filter-continent [correctForm]="form" #filterContinent></app-filter-continent>
  <app-filter-category
    *ngIf="!hideFilterCategory"
    [correctForm]="form"
    [featured]="featured"
    [hidePromoted]="hidePromoted"
    [isEvent]="isEvent"
    #filterCategory
  ></app-filter-category>
  <div class="filters-mobile__footer display-mobile">
    <button class="btn btn--primary btn--md btn--block" (click)="toggleFilters()">
      {{ 'PROJECTS.FILTERS.apply_filters' | translate }}
    </button>
  </div>
</div>
